import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '@mui/material';

import { NotEnoughAttemptsError, NotEnoughCreditsError, UnauthorizedError } from 'queries/bulletins/use-ai-insights';

import ChevronUpDoubleIcon from './assets/chevron-up-double.svg';
import RepeatIcon from './assets/repeat.svg';
import useStyles from './styles';

interface Props {
    error: Error;
    onRetry?: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
}

const OopsMessage: React.FC<Props> = ({ error, onRetry, className }) => {
    const { classes, cx } = useStyles();
    const location = useLocation();
    return (
        <div className={cx(classes.root, className)}>
            {error instanceof NotEnoughCreditsError ? (
                <>
                    <p className={classes.title}>{'Not enough credits'}</p>
                    <Button
                        variant="contained"
                        startIcon={<ChevronUpDoubleIcon />}
                        disableElevation
                        disableRipple
                        component={Link}
                        to={'/company/contacts'}
                        className={classes.action}
                    >
                        {'Upgrade plan'}
                    </Button>
                </>
            ) : error instanceof NotEnoughAttemptsError ? (
                <>
                    <p className={classes.title}>{'You have reached limit for today'}</p>
                    <Button
                        variant="contained"
                        startIcon={<ChevronUpDoubleIcon />}
                        disableElevation
                        disableRipple
                        component={Link}
                        to={'/company/contacts'}
                        className={classes.action}
                    >
                        {'Upgrade plan'}
                    </Button>
                </>
            ) : error instanceof UnauthorizedError ? (
                <>
                    <p className={classes.title}>{'You are not authorized'}</p>
                    <Button
                        variant="contained"
                        startIcon={<ChevronUpDoubleIcon />}
                        disableElevation
                        disableRipple
                        component={Link}
                        to={{
                            pathname: '/login',
                            state: { from: location.pathname + location.search }
                        }}
                        className={classes.action}
                    >
                        {'Login'}
                    </Button>
                </>
            ) : (
                <>
                    <p className={classes.title}>{'We were unable to generate AI insights, please try again'}</p>
                    <Button
                        variant="contained"
                        startIcon={<RepeatIcon />}
                        disableElevation
                        disableRipple
                        onClick={onRetry}
                        className={classes.action}
                    >
                        {'Try again'}
                    </Button>
                </>
            )}
        </div>
    );
};

export default OopsMessage;
